import { render, staticRenderFns } from "./DialogId1.vue?vue&type=template&id=f78a3a2a&scoped=true&"
import script from "./DialogId1.vue?vue&type=script&lang=js&"
export * from "./DialogId1.vue?vue&type=script&lang=js&"
import style0 from "./DialogId1.vue?vue&type=style&index=0&id=f78a3a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78a3a2a",
  null
  
)

export default component.exports